import React, { useState } from "react";
import { BarChart } from "@mui/icons-material";
import { ListItemIcon, MenuItem } from "@mui/material";

import { useFeatureFlag } from "fond/featureFlags";
import useProjectHasScenarioConfiguration from "fond/hooks/useProjectHasScenarioConfiguration";
import BomModal from "fond/project/bom/BomModal";
import { Architecture, Project } from "fond/types";
import { isPlannerProject } from "fond/utils/project";

import { trackPageMenuItemClick } from "../helper";

interface IProps {
  project: Project;
  architecture: Architecture | null;
  handleClose: () => void;
}

const Bom: React.FC<IProps> = ({ project, architecture, handleClose }: IProps) => {
  const [bomModal, showBomModal] = useState(false);
  const { value: canAccessGridBom } = useFeatureFlag("grid_bom");
  const { hasConfig: isCollaborationCostToServe } = useProjectHasScenarioConfiguration({ projectId: project?.ID });
  const canViewBom = isPlannerProject(project) || (canAccessGridBom && isCollaborationCostToServe);
  const handleClick = () => {
    if (canViewBom) {
      showBomModal(true);
      handleClose();
      trackPageMenuItemClick("project", "bom", project);
    }
  };

  return (
    <>
      <MenuItem data-testid="bom-button" onClick={handleClick} disabled={!canViewBom}>
        <ListItemIcon>
          <BarChart />
        </ListItemIcon>
        Bills of Materials
      </MenuItem>
      {bomModal && <BomModal project={project} architecture={architecture} onClose={() => showBomModal(false)} />}
    </>
  );
};

export default Bom;
